<template>
  <v-app>
    <div v-if="this.$route.name !== 'Entrar' && this.$route.name !== 'Error'">
      <menu-principal/>
    </div>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
    MenuPrincipal: () => import("@/components/menus/menu.vue"),
  },

  data: () => ({
    //
  }),
};
</script>
